import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {AlertService, ConfirmService, SessionModel, SiteModel, UserSession} from '@/sdk';
import {ReportsApi, SitesApi} from '@/sdk/api-services';
import ProjectSelectionDialogComponent from '@/views/shared/project-selection-dialog/project-selection-dialog.component';
import {JobLocationService, SiteProjectsService, SiteTeamMembersService} from '@/views/shared/services';
import {JobService} from '@/views/shared/services/job.service';
import {SiteLocationService} from '@/views/shared/services/site-location.service';
import {Component} from 'vue-property-decorator';
import SiteSetupAreaBrowserComponent from '../../client/site-setup/site-setup-area-browser/site-setup-area-browser.component';
import JobReportAreaBrowserComponent from '../job-report-area-browser/job-report-area-browser.component';
import JobReportFilterComponent from '../job-report-filter/job-report-filter.component';
import ReportListingComponent from '../report-listing/report-listing.component';

@Component({
    name: 'JobSetupMainComponent',
    components: {
        SiteSetupAreaBrowserComponent,
        JobReportAreaBrowserComponent,

        ProjectSelectionDialogComponent,

        JobReportFilterComponent,
        ReportListingComponent,
    },
})
export default class JobReportMainComponent extends VueWrapper {
    public $refs!: {
        areaBrowserElem: HTMLDivElement;
        jobListElem: HTMLDivElement;
        jobListParentElem: HTMLDivElement;
        projectSelectionDialogRef: ProjectSelectionDialogComponent;
        reportListingRef: ReportListingComponent;
    };

    public siteToEdit: SiteModel = new SiteModel();

    public siteId: string | null = null;
    public projectId: string | null = null;

    public jobLocationsSrv: JobLocationService = new JobLocationService();
    public siteLocationsSrv: SiteLocationService = new SiteLocationService();
    public siteProjectsSrv: SiteProjectsService = new SiteProjectsService();
    public reportsApi: ReportsApi = new ReportsApi();

    public siteTeamMembersSrv: SiteTeamMembersService = new SiteTeamMembersService();
    public jobService: JobService = new JobService();

    public ConfirmSrv = new ConfirmService();
    public AlertSrv = new AlertService();

    public reportsStatistics: Record<string, number> = {};

    public locationPath: Array<{id: string; title: string; type: string}> = [];

    public value: any = '';
    public events: any = [];
    public colors: any = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
    public names: any = ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'];

    //INPUTS
    titleInput: String | null = null;
    typeInput: String | null = null;
    areaInput: String | null = null;
    subAreaInput: String | null = null;
    flammableInput: String | null = null;
    explosionInput: String | null = null;
    ipxInput: String | null = null;
    ipyInput: String | null = null;
    ambTempInput: String | null = null;
    inspFrequencyInput: String | null = null;
    approvalTypeInput: String | null = null;
    gasZoneInput: String | null = null;
    gasGroupInput: String | null = null;
    tempClassInput: String | null = null;
    dustZoneInput: String | null = null;
    dustGroupInput: String | null = null;
    dustIgnitionSelectionInput: String | null = null;
    dustIgnitionInput: String | null = null;
    envCondInput: String | null = null;

    /////////////////////////////////////////////
    public classification: string | null = null;
    public equipmentTypeSelected: string | null = null;

    public startX: number | null = null;
    public startY: number | null = null;
    public startWidth: number | null = null;
    public startHeight: number | null = null;

    public onBrowserMouseDown(e: any) {
        this.startX = e.clientX;
        this.startY = e.clientY;
        this.startWidth = parseInt(document.defaultView?.getComputedStyle(this.$refs.areaBrowserElem)?.width ?? '0', 10);
        // this.startHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.areaBrowserElem)?.height ?? '0', 10);

        document.documentElement.addEventListener('mousemove', this.doDrag, false);
        document.documentElement.addEventListener('mouseup', this.stopDrag, false);
    }

    doDrag(e: any) {
        this.$refs.areaBrowserElem.style.width = `${this.startWidth + e.clientX - (this.startX ?? 0)}px`;
        // this.$refs.areaBrowserElem.style.height = `${this.startHeight + e.clientY - (this.startY ?? 0)}`;
    }

    stopDrag(e: any) {
        document.documentElement.removeEventListener('mousemove', this.doDrag, false);
        document.documentElement.removeEventListener('mouseup', this.stopDrag, false);
    }

    public startX1: number | null = null;
    public startY1: number | null = null;
    public startWidth1: number | null = null;
    public jobListElemHeight: number | null = null;

    public parentHeight: number | null = null;
    public currentHeight: number = 0;

    public onListMouseDown(e: any) {
        this.startX1 = e?.clientX ?? 0;
        this.startY1 = e?.clientY ?? 0;
        // this.startWidth1 = parseInt(document.defaultView?.getComputedStyle(this.$refs.jobListElem)?.width ?? '0', 10);
        this.jobListElemHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.jobListElem)?.height ?? '0', 10);

        // this.parentHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.jobListParentElem)?.height ?? '0', 10);

        document.documentElement.addEventListener('mousemove', this.doDrag1, false);
        document.documentElement.addEventListener('mouseup', this.stopDrag1, false);
    }

    doDrag1(e: any) {
        // this.$refs.jobListElem.style.width = `${this.startWidth1 + e.clientX - (this.startX1 ?? 0)}px`;
        this.currentHeight = this.jobListElemHeight + e.clientY - (this.startY1 ?? 0);
        this.$refs.jobListElem.style.height = `${this.currentHeight}px`;
    }

    stopDrag1(e: any) {
        document.documentElement.removeEventListener('mousemove', this.doDrag1, false);
        document.documentElement.removeEventListener('mouseup', this.stopDrag1, false);
    }

    public inilizeHeights() {
        this.parentHeight = parseInt(document.defaultView?.getComputedStyle(this.$refs.jobListParentElem)?.height ?? '0', 10);
        if (this.parentHeight > 10) {
            this.parentHeight = this.parentHeight - 4;
        }

        this.jobListElemHeight = this.parentHeight / 6 - 1;
        this.currentHeight = this.jobListElemHeight;
    }

    public get equipmentTypes(): Array<any> {
        if (this.siteLocationsSrv.selectedLcoation?.equipmentDetail?.equipmentClassification) {
            return this.$formOptions.equipmentTypesList[this.siteLocationsSrv.selectedLcoation!.equipmentDetail!.equipmentClassification as any] as Array<any>;
        }
        return [];
    }

    // Change to protectionTechniquesSubDYD
    public get protectionTechniquesDYD(): Array<any> {
        if (this.siteLocationsSrv.selectedLcoation?.equipmentDetail?.protectionTechniqueGas) {
            return this.$formOptions.protectionTechniquesDYDList[
                this.siteLocationsSrv.selectedLcoation!.equipmentDetail!.protectionTechniqueGas as any
            ] as Array<any>;
        }
        return [];
    }

    public mouseDrag: boolean = false;

    public userSession: UserSession = new UserSession();

    public created() {
        this.siteId = this.$route.params['siteId'];
    }
    public async mounted() {
        this.siteProjectsSrv.reset();
        this.jobService.reset();

        this.inilizeHeights();

        // this.inspectorService.getInspectors(this.siteId);
        this.siteTeamMembersSrv.getSiteWorkers(this.siteId);
        this.siteTeamMembersSrv.getJobManagers(this.siteId);
        // this.siteTeamMembersSrv.getSafetyManagers(this.siteId);
        // this.siteTeamMembersSrv.getSafetyOfficers(this.siteId);
        // this.siteTeamMembersSrv.getOperationManagers(this.siteId);

        this.getSiteToEdit(this.siteId!);

        // this.jobLocationsSrv.getSiteLocations(this.siteId!);
        // this.jobLocationsSrv.selectedLcoation = null;

        //call jobs
        // this.getJobsDB();
    }

    public getSiteToEdit(id: string) {
        this.LoaderSrv.showFullScreenLoader();
        new SitesApi()
            .getSiteById(id)
            .subscribe(
                res => {
                    this.siteToEdit = res.Data ?? new SiteModel();
                    // this.jobLocationsSrv.site = this.siteToEdit;
                },
                err => {
                    this.AlertSrv.show('error', err.message ?? err.Message ?? 'Unable to load site.');
                }
            )
            .add(() => {
                this.LoaderSrv.hideFullScreenLoader();
            });
    }

    getEventColor(event: any) {
        return event.color;
    }

    public getReportsStatistics() {
        if (this.siteId) {
            this.reportsApi
                .getReportsStatistics(this.siteId!)
                .then(res => {
                    this.reportsStatistics = res.reportsByType ?? {};
                })
                .catch(err => {})
                .finally(() => {});
        }
    }

    public generateSiteInformationReport() {
        const session: SessionModel | null = this.userSession.Session;
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Site Information Report', 'Are you sure you want to generate site information report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Site Information report...');
                    this.reportsApi
                        .generateSiteInformationReport(this.siteId!, session)
                        .then(res => {
                            this.AlertSrv.show('success', 'Site Information report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site to generate report.');
        }
    }

    public generateAreaReport() {
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Area Report', 'Are you sure you want to generate area report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Area report...');
                    this.reportsApi
                        .generateAreaReport(this.siteId!, undefined, true)
                        .then(res => {
                            this.AlertSrv.show('success', 'Area report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site to generate report.');
        }
    }

    public generateEquipmentReport() {
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Equipment Report', 'Are you sure you want to generate equipment report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Equipment report...');
                    this.reportsApi
                        .generateEquipmentReport(this.siteId!, undefined, true)
                        .then(res => {
                            this.AlertSrv.show('success', 'Equipment report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        }
    }

    public generateInspectionReport() {
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Inspection Report', 'Are you sure you want to generate inspection report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Inspection report...');
                    this.reportsApi
                        .generateInspectionReport(this.siteId!, undefined, undefined, true)
                        .then(res => {
                            this.AlertSrv.show('success', 'Inspection report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site to generate report.');
        }
    }

    public openProjectSelectionDialog() {
        if (this.siteId) {
            this.$refs.projectSelectionDialogRef.open();
        }
    }

    public projectSelected() {
        this.projectId = this.siteProjectsSrv.selectedProject?.id ?? null;
        this.generateProjectReport();
    }

    public generateProjectReport() {
        const session: SessionModel | null = this.userSession.Session;
        if (this.siteId && this.projectId) {
            this.ConfirmSrv.open('Generate Project Report', 'Are you sure you want to generate project report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Project report...');
                    this.reportsApi
                        .generateJobReport(this.siteId!, this.projectId!, session)
                        .then(res => {
                            this.AlertSrv.show('success', 'Project report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site and project to generate report.');
        }
    }

    public generatePeriodicReport() {
        const session: SessionModel | null = this.userSession.Session;
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Periodic Report', 'Are you sure you want to generate periodic report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Periodic report...');
                    this.reportsApi
                        .generatePeriodicReport(this.siteId!, session)
                        .then(res => {
                            this.AlertSrv.show('success', 'Periodic report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site to generate report.');
        }
    }

    public generateIntrinsicSafetyReport() {
        if (this.siteId) {
            this.ConfirmSrv.open('Generate Intrinsic Safety Report', 'Are you sure you want to generate intrinsic safety report?').then(confirmed => {
                if (confirmed) {
                    this.LoaderSrv.showFullScreenLoader('Generating Intrinsic Safety report...');
                    this.reportsApi
                        .generateIntrinsicSafetyReport(this.siteId!, true)
                        .then(res => {
                            this.AlertSrv.show('success', 'Intrinsic Safety report generated successfully.');
                            this.$refs.reportListingRef?.getReports();
                        })
                        .catch(err => {
                            this.AlertSrv.show('error', err.message ?? 'Unable to download report.');
                        })
                        .finally(() => {
                            this.LoaderSrv.hideFullScreenLoader();
                        });
                }
            });
        } else {
            this.AlertSrv.show('error', 'Please select a site to generate report.');
        }
    }
}
